import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import useCommonHooks from "./hooks/useCommonHooks";
import Toaster from "./components/mui/Toaster";
import Head from "./Head";
import { useDispatch, useSelector } from "react-redux";
import { getParamFromUrl, setCookie } from "./utils/utils.js";
import { DEBUG, TEST_MODE } from "./store/enums";
import { setModalFortune } from "./store/siteSlice.js";
import LiveChat from "./components/LiveChat.jsx";
import ShowContainer from "./components/mui/ShowContainer.jsx";
import ErrorBoundary from "./components/mui/error_boundary/ErrorBoundary.jsx";
import "./style/common.scss";
import { ENUM_HASH } from "./hooks/other/useUrlParc.js";
import LoaderContainer from "./components/mui/loader_container/LoaderContainer.jsx";
import CommonModals from "./components/common_modals/CommonModals.jsx";

const Main = lazy(() => import("./pages/main"));
const Game = lazy(() => import("./pages/game"));
const BonusGame = lazy(() => import("./pages/bonusGame"));
const Games = lazy(() => import("./pages/games"));
const Terms = lazy(() => import("./pages/terms"));
const Banner = lazy(() => import("./pages/banner.jsx"));
const Promotions = lazy(() => import("./pages/promotions.jsx"));
const ConfirmEmail = lazy(() => import("./pages/confirmEmail.jsx"));
const NewPassword = lazy(() => import("./pages/newPassword.jsx"));
const Categories = lazy(() => import("./pages/categories.jsx"));
const WagerGames = lazy(() => import("./pages/wagerGames.jsx"));

const FortuneModal = lazy(() => import("./components/modal/fortune_modal/FortuneModal.jsx"));
const BottomNavigation = lazy(() => import("./components/bottom_navigation/BottomNavigation.jsx"));

export default function App() {
  const sessionId = getParamFromUrl("sessionId");
  const isTgBot = useSelector((state) => state.common.isTgBot);

  if (sessionId && isTgBot) {
    if (DEBUG) console.log("document.cookie", document.cookie);
    if (DEBUG) console.log("set cookie", sessionId);
    setCookie("_GCS_SID_", sessionId);
    if (DEBUG) console.log("document.cookie", document.cookie);
  }

  return (
    <BrowserRouter>
      <NavigateOnLoad />

      <Suspense fallback={<LoaderContainer fullHeight loader />}>
        <Routes>
          <Route path="/game/:id" element={<Game />} />
          <Route path="/games/:id/:subId" element={<Games />} />
          <Route path="/games/:id" element={<Games />} />
          <Route path="/bonus_game/:id" element={<BonusGame />} />
          <Route path="/banner/:id" element={<Banner />} />
          <Route path="/confirm_email/:code" element={<ConfirmEmail />} />
          <Route path="/new_password/:code" element={<NewPassword />} />
          <Route path="/categories/:categoryId" element={<Categories />} />
          <Route path="/wager_games" element={<WagerGames />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/*" element={<Main />} />
        </Routes>
      </Suspense>

      <ErrorBoundary>
        <Suspense>
          <BottomNavigation />
        </Suspense>
      </ErrorBoundary>
      <CommonModals />
      <Toaster />
    </BrowserRouter>
  );
}

function NavigateOnLoad() {
  useCommonHooks();
  const logoUrl = useSelector((state) => state.common.logoUrl);
  const openFortune = useSelector((state) => state.site.modals.fortune);
  const { hash } = useLocation();
  const dispatch = useDispatch();

  const closeFortune = () => dispatch(setModalFortune(false));
  const shouldMountFortune =
    openFortune || hash === ENUM_HASH.fortune || hash === ENUM_HASH.fortune_on;

  return (
    <>
      <Head favicon={logoUrl} appleTouchIcon={logoUrl} />
      {shouldMountFortune && (
        <Suspense fallback={null}>
          <FortuneModal isOpen={!!openFortune} closeModal={closeFortune} />
        </Suspense>
      )}
      <ShowContainer condition={!TEST_MODE}>
        <LiveChat />
      </ShowContainer>
    </>
  );
}
